const fieldViewDictionary = {
  fieldView: {
    boolean: {
      yes: "Yes",
      no: "No"
    },
    fallback: {
      unknown: "unknown",
      notAvailable: "N/A"
    }
  }
};
export {
  fieldViewDictionary
};
//# sourceMappingURL=fieldViewDictionary.js.map
